// BlogSection.jsx
import React from "react";
import { Link } from "react-router-dom";
import './blog-section.css';

export const BlogSection = () => {
  const blogs = [
    {
      id: 1,
      title: "Solar Panel Subsidy in Delhi NCR - Complete Guide 2023",
      excerpt: "Learn how to avail up to 40% subsidy on solar installations in Delhi, Noida & Ghaziabad under central government schemes.",
      image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      date: "June 15, 2023",
      tags: ["Solar Subsidy", "Delhi Solar", "Free Solar Scheme"],
      slug: "solar-panel-subsidy-delhi-ncr-guide-2023"
    },
    {
      id: 2,
      title: "Rooftop Solar Installation: Cost vs Savings Analysis",
      excerpt: "Detailed breakdown of 5kW solar system costs in NCR region and how much you can save with net metering benefits.",
      image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      date: "May 28, 2023",
      tags: ["Solar ROI", "Solar Noida", "Solar Cost"],
      slug: "rooftop-solar-installation-cost-savings-analysis"
    },
    {
      id: 3,
      title: "PM Surya Ghar Muft Bijli Yojana - How to Apply Online",
      excerpt: "Step-by-step guide to register for free solar electricity scheme for residential consumers in Uttar Pradesh.",
      image: "https://images.unsplash.com/photo-1541167760496-1628856ab772?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      date: "April 10, 2023",
      tags: ["Free Solar", "Govt Scheme", "UP Solar"],
      slug: "pm-surya-ghar-muft-bijli-yojana-application-guide"
    }
  ];

  return (
    <section id="blog" className="blog-section">
      <div className="container">
        <div className="section-title text-center">
          <h2>Solar Energy Blog</h2>
          <p>Latest updates on solar policies, schemes and technologies in India</p>
        </div>
        <div className="row">
          {blogs.map(blog => (
            <div key={blog.id} className="col-md-4">
              <div className="blog-card">
                <div className="blog-image">
                  <img src={blog.image} alt={blog.title} />
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <span className="date">{blog.date}</span>
                    <div className="tags">
                      {blog.tags.map(tag => (
                        <span key={tag} className="tag">{tag}</span>
                      ))}
                    </div>
                  </div>
                  <h3 className="blog-title">{blog.title}</h3>
                  <p className="blog-excerpt">{blog.excerpt}</p>
                  <Link to={`/blog/${blog.slug}`} className="read-more">
                    Read Full Article →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};